import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shc-payment-complete',
  templateUrl: './payment-complete.page.html',
  styleUrls: ['./payment-complete.page.scss'],
})
export class PaymentCompletePage implements OnInit {

  constructor() { }

  ngOnInit() {}

}
